// import React, { useEffect, useState } from "react";
// import { Modal, Input, message, Spin, Select, Form } from "antd";
// import { useUserContext } from "../context/dashboard-context";
// import CustomPagination from "../components/pagination";
// import BannerImageUploader from "../components/imageUploader/BannerImageUploader";
// import api from "../context/api";
// import BannerCard from "../components/banner-card/Bannercard";
// import "./banner.scss";

// const { Option } = Select;

// const BannersPage = () => {
//   const { banners, GetBanners, totalBanners } = useUserContext();
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [form] = Form.useForm();

//   const [formData, setFormData] = useState({
//     title_uz: "",
//     title_ru: "",
//     title_en: "",
//     imageFile: null,
//     link_type: "external",
//     link_target: "",
//     is_active: true,
//   });

//   const fetchBanners = async (page = 1) => {
//     setLoading(true);
//     try {
//       await GetBanners(page);
//       setCurrentPage(page);
//     } catch (error) {
//       console.error("Error fetching banners:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchBanners(1);
//   }, []);

//   const addBanner = async (values) => {
//     setLoading(true);

//     if (!formData.imageFile) {
//       message.error("Iltimos, rasm yuklang");
//       setLoading(false);
//       return;
//     }

//     const formDataToSend = new FormData();
//     Object.entries(values).forEach(([key, value]) => {
//       formDataToSend.append(key, value);
//     });
//     formDataToSend.append("image", formData.imageFile);

//     try {
//       const response = await api.post("/banner/", formDataToSend, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       if ([200, 201].includes(response.status)) {
//         message.success("Banner muvaffaqiyatli qo'shildi");
//         await fetchBanners(1);
//         handleCancel();
//       }
//     } catch (error) {
//       console.error("Error adding banner:", error.response?.data);
//       message.error(
//         error.response?.data?.message || "Banner qo'shishda xatolik yuz berdi"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCancel = () => {
//     // Reset form fields
//     form.resetFields();
//     // Clear image file
//     setFormData({
//       title_uz: "",
//       title_ru: "",
//       title_en: "",
//       imageFile: null,
//       link_type: "external",
//       link_target: "",
//       is_active: true,
//     });
//     // Close modal
//     setIsModalOpen(false);
//   };

//   return (
//     <div className="banners-page">
//       <div className="page-header">
//         <h1>Bannerlar</h1>
//         <button onClick={() => setIsModalOpen(true)}>
//           + Yangi banner qo'shish
//         </button>
//       </div>

//       {loading && banners.length === 0 ? (
//         <Spin size="large" />
//       ) : (
//         <>
//           <div className="banners-grid">
//             {banners.map((banner) => (
//               <BannerCard
//                 key={banner.id}
//                 banner={banner}
//                 onUpdate={() => fetchBanners(currentPage)}
//               />
//             ))}
//           </div>

//           <CustomPagination
//             current={currentPage}
//             total={totalBanners}
//             onChange={(page) => fetchBanners(page)}
//           />
//         </>
//       )}

//       <Modal
//         title="Yangi banner qo'shish"
//         open={isModalOpen}
//         onCancel={handleCancel}
//         footer={null}
//         width={800}
//       >
//         <Spin spinning={loading}>
//           <Form
//             form={form}
//             onFinish={addBanner}
//             initialValues={{ link_type: "external", is_active: true }}
//           >
//             <Form.Item
//               name="title_uz"
//               label="Sarlavha (O'zbekcha)"
//               rules={[{ required: true }]}
//             >
//               <Input />
//             </Form.Item>
//             <Form.Item
//               name="title_ru"
//               label="Sarlavha (Ruscha)"
//               rules={[{ required: true }]}
//             >
//               <Input />
//             </Form.Item>
//             <Form.Item name="title_en" label="Sarlavha (Inglizcha)">
//               <Input />
//             </Form.Item>
//             <Form.Item
//               name="link_type"
//               label="Havola turi"
//               rules={[{ required: true }]}
//             >
//               <Select>
//                 <Option value="category">Kategoriya</Option>
//                 <Option value="external">Tashqi havola</Option>
//               </Select>
//             </Form.Item>
//             <Form.Item
//               name="link_target"
//               label="Havola manzili"
//               rules={[{ required: true }]}
//             >
//               <Input placeholder="4|Ronaldo yoki https://example.com" />
//             </Form.Item>
//             <Form.Item name="is_active" label="Faollik holati">
//               <Select>
//                 <Option value={true}>Ha</Option>
//                 <Option value={false}>Yo'q</Option>
//               </Select>
//             </Form.Item>
//             <Form.Item label="Rasm" required>
//               <BannerImageUploader
//                 imageFile={formData.imageFile}
//                 setImageFile={(file) =>
//                   setFormData((prev) => ({ ...prev, imageFile: file }))
//                 }
//               />
//             </Form.Item>
            
//             <div style={{ display: 'flex', gap: '16px', marginTop: '24px',transform: 'translateX(140px)' }}>
//               <button
//                 type="button"
//                 className="cancel-btn"
//                 onClick={handleCancel}
//                 style={{
//                   padding: "14px 24px",
//                   backgroundColor: "#f5f5f5",
//                   color: "rgba(0, 0, 0, 0.85)",
//                   border: "1px solid #d9d9d9",
//                   borderRadius: "4px",
//                   cursor: "pointer",
//                   fontSize: "14px",
//                   fontWeight: "500",
//                   transition: "all 0.3s",
//                   height: "40px",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   justifyContent: "center",
                  
//                   "&:hover": {
//                     color: "#1890ff",
//                     borderColor: "#1890ff"
//                   },
                  
//                   "&:active": {
//                     color: "#096dd9",
//                     borderColor: "#096dd9"
//                   }
//                 }}
//               >
//                 Bekor qilish
//               </button>
              
//               <button
//                 type="submit"
//                 className="submit-btn"
//                 disabled={!formData.imageFile}
//                 style={{
//                   padding: "14px 24px",
//                   backgroundColor: "#1890ff",
//                   color: "white",
//                   border: "none",
//                   borderRadius: "4px",
//                   cursor: "pointer",
//                   fontSize: "14px",
//                   fontWeight: "500",
//                   transition: "all 0.3s",
//                   height: "40px",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   justifyContent: "center",

//                   // Disabled state styling
//                   "&:disabled": {
//                     backgroundColor: "#f5f5f5",
//                     color: "rgba(0, 0, 0, 0.25)",
//                     cursor: "not-allowed",
//                     borderColor: "#d9d9d9",
//                   },

//                   // Hover state
//                   "&:not(:disabled):hover": {
//                     backgroundColor: "#40a9ff",
//                   },

//                   // Active state
//                   "&:not(:disabled):active": {
//                     backgroundColor: "#096dd9",
//                   },
//                 }}
//               >
//                 Qo'shish
//               </button>
//             </div>
//           </Form>
//         </Spin>
//       </Modal>
//     </div>
//   );
// };

// export default BannersPage;


import React, { useEffect, useState } from "react";
import { Modal, Input, message, Spin, Select, Form } from "antd";
import { useUserContext } from "../context/dashboard-context";
import CustomPagination from "../components/pagination";
import BannerImageUploader from "../components/imageUploader/BannerImageUploader";
import api from "../context/api";
import BannerCard from "../components/banner-card/Bannercard";
import "./banner.scss";

const { Option } = Select;

const BannersPage = () => {
  const { banners, GetBanners, totalBanners } = useUserContext();
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categoryLoading, setCategoryLoading] = useState(false);

  const [formData, setFormData] = useState({
    title_uz: "",
    title_ru: "",
    title_en: "",
    imageFile: null,
    link_type: "external",
    link_target: "",
    is_active: true,
  });

  const fetchBanners = async (page = 1) => {
    setLoading(true);
    try {
      await GetBanners(page);
      setCurrentPage(page);
    } catch (error) {
      console.error("Bannerlarni yuklashda xatolik:", error);
      message.error("Bannerlarni yuklashda xatolik yuz berdi");
    } finally {
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    setCategoryLoading(true);
    try {
      const response = await api.get("/category/");
      setCategories(response.data);
    } catch (error) {
      console.error("Kategoriyalarni yuklashda xatolik:", error);
      message.error("Kategoriyalarni yuklashda xatolik yuz berdi");
    } finally {
      setCategoryLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners(1);
    fetchCategories();
  }, []);

  const addBanner = async (values) => {
    setLoading(true);

    if (!formData.imageFile) {
      message.error("Iltimos, rasm yuklang");
      setLoading(false);
      return;
    }

    const formDataToSend = new FormData();
    
    Object.entries(values).forEach(([key, value]) => {
      if (key !== 'link_target') {
        formDataToSend.append(key, value);
      }
    });

    if (values.link_type === 'category' && selectedCategory) {
      formDataToSend.append('link_target', selectedCategory.id.toString());
    } else {
      formDataToSend.append('link_target', values.link_target);
    }

    formDataToSend.append("image", formData.imageFile);

    try {
      const response = await api.post("/banner/", formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if ([200, 201].includes(response.status)) {
        message.success("Banner muvaffaqiyatli qo'shildi");
        await fetchBanners(1);
        handleCancel();
      }
    } catch (error) {
      console.error("Banner qo'shishda xatolik:", error.response?.data);
      message.error(
        error.response?.data?.message || "Banner qo'shishda xatolik yuz berdi"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setFormData({
      title_uz: "",
      title_ru: "",
      title_en: "",
      imageFile: null,
      link_type: "external",
      link_target: "",
      is_active: true,
    });
    setSelectedCategory(null);
    setIsModalOpen(false);
  };

  return (
    <div className="banners-page">
      <div className="page-header">
        <h1>Bannerlar</h1>
        <button onClick={() => setIsModalOpen(true)}>
          + Yangi banner qo'shish
        </button>
      </div>

      {loading && banners.length === 0 ? (
        <Spin size="large" />
      ) : (
        <>
          <div className="banners-grid">
            {banners.map((banner) => (
              <BannerCard
                key={banner.id}
                banner={banner}
                onUpdate={() => fetchBanners(currentPage)}
                categories={categories}
              />
            ))}
          </div>

          <CustomPagination
            current={currentPage}
            total={totalBanners}
            onChange={(page) => fetchBanners(page)}
          />
        </>
      )}

      <Modal
        title="Yangi banner qo'shish"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        width={800}
      >
        <Spin spinning={loading || categoryLoading}>
          <Form
            form={form}
            onFinish={addBanner}
            initialValues={{ link_type: "external", is_active: true }}
          >
            <Form.Item
              name="title_uz"
              label="Sarlavha (O'zbekcha)"
              rules={[{ required: true, message: "Iltimos, sarlavhani kiriting" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="title_ru"
              label="Sarlavha (Ruscha)"
              rules={[{ required: true, message: "Iltimos, sarlavhani kiriting" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="title_en"
              label="Sarlavha (Inglizcha)"
            >
              <Input />
            </Form.Item>
            
            <Form.Item
              name="link_type"
              label="Havola turi"
              rules={[{ required: true, message: "Iltimos, havola turini tanlang" }]}
            >
              <Select onChange={(value) => {
                if (value === 'external') {
                  setSelectedCategory(null);
                }
              }}>
                <Option value="category">Kategoriya</Option>
                <Option value="external">Tashqi havola</Option>
              </Select>
            </Form.Item>
            
            <Form.Item noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const linkType = getFieldValue('link_type');
                if (linkType === 'category') {
                  return (
                    <Form.Item
                      name="category_id"
                      label="Kategoriya"
                      rules={[{ required: true, message: "Iltimos, kategoriyani tanlang" }]}
                    >
                      <Select
                        showSearch
                        placeholder="Kategoriyani tanlang"
                        optionFilterProp="children"
                        onChange={(value) => {
                          const category = categories.find(c => c.id === value);
                          setSelectedCategory(category);
                        }}
                        filterOption={(input, option) =>
                          option.children.toLowerCase().includes(input.toLowerCase())
                        }
                        loading={categoryLoading}
                      >
                        {categories.map(category => (
                          <Option key={category.id} value={category.id}>
                            {category.name_uz}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  );
                }
                return (
                  <Form.Item
                    name="link_target"
                    label="Havola manzili"
                    rules={[{ required: true, message: "Iltimos, havola manzilini kiriting" }]}
                  >
                    <Input placeholder="https://example.com" />
                  </Form.Item>
                );
              }}
            </Form.Item>
            
            <Form.Item
              name="is_active"
              label="Faollik holati"
              rules={[{ required: true, message: "Iltimos, holatni tanlang" }]}
            >
              <Select>
                <Option value={true}>Faol</Option>
                <Option value={false}>Faol emas</Option>
              </Select>
            </Form.Item>
            
            <Form.Item
              label="Rasm"
              required
              rules={[{ required: true, message: "Iltimos, rasm yuklang" }]}
            >
              <BannerImageUploader
                imageFile={formData.imageFile}
                setImageFile={(file) =>
                  setFormData((prev) => ({ ...prev, imageFile: file }))
                }
              />
            </Form.Item>
            
            <div className="form-actions">
              <button
                type="button"
                className="cancel-btn"
                onClick={handleCancel}
              >
                Bekor qilish
              </button>
              
              <button
                type="submit"
                className="submit-btn"
                disabled={!formData.imageFile}
              >
                Qo'shish
              </button>
            </div>
          </Form>
        </Spin>
      </Modal>
    </div>
  );
};

export default BannersPage;